import { render, staticRenderFns } from "./policy-status-select.vue?vue&type=template&id=4d6a6acf"
import script from "./policy-status-select.vue?vue&type=script&lang=js"
export * from "./policy-status-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports